module.exports = __webpack_public_path__ + "img/SK.853919fd.svg";